module.exports = __webpack_public_path__ + "static/img/m5.d2a3794.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m5.jpg
// module id = 2W67
// module chunks = 1